import { getBookImage } from './getBookImage';

export const formatBook = (book) => {
  const product = book?.product;
  const details = product ? book.product : book;
  const title = book?.title || details.title;
  const subtitle = book?.subtitle || details.subtitle;
  const fullTitle = `${title}${subtitle ? ` - ${subtitle}` : ``}`;
  const image = getBookImage(book);

  return {
    ...book,
    ...details,
    title,
    subtitle,
    fullTitle,
    image,
    id: book.id,
    createdAt: book.createdAt,
    updatedAt: book.updatedAt,
  };
};
